import { Link } from "react-router-dom";

// Components
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Seo from "../../components/Seo";

// CSS Styling
import "../../styles/notFound.css";

const NotFound = () => {
  return (
    <div>
      <Seo
        title="Page not found"
        description="The page you are looking for does not exist or has moved."
        noindex
      />
      <Header />
      <main className="notFoundContainer">
        <p className="notFoundCode">404</p>
        <h1 className="notFoundTitle">Page not found</h1>
        <p className="notFoundText">
          The page you are looking for does not exist or has moved.
        </p>
        <div className="notFoundLinks">
          <Link to="/" className="notFoundButton">
            Back to home
          </Link>
          <Link to="/expertise" className="notFoundLink">
            Our expertise
          </Link>
          <Link to="/blog" className="notFoundLink">
            Blog
          </Link>
          <Link to="/contact" className="notFoundLink">
            Contact us
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
